import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Upload,
  notification,
  DatePicker,
  Select,
  Alert,
} from "antd";
import {
  PlusOutlined,
  MailFilled,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import { odata } from "./../Filters/Helper";
import moment from "moment";
import { get } from "lodash";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};
const dateFormat = "DD/MM/YYYY";

const ProjectStepUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [selectedTenantUserIds, setSelectedTenantUserIds] = useState([]);
  const [tenantUserSelect, setTenantUserSelect] = useState({
    data: [],
    loading: false,
  });
  const [defaultTenantUserIds, setDefaultTenantUserIds] = useState([]);
  const [lastSelectedTenantUserIds, setLastSelectedTenantUserIds] = useState(
    []
  );
  const [projectStatusSelect, setProjectStatusSelect] = useState({
    data: [],
    loading: false,
  });

  const [isEditAllowed, setIsEditAllowed] = useState(true);

  useEffect(() => {
    if (props.data) {
      if (props.data.startDate) {
        props.data.startDate = moment(props.data.startDate);
      }
      if (props.data.endDate) {
        props.data.endDate = moment(props.data.endDate);
      }

      form.setFieldsValue(props.data);
    }

    RequestHandler.get(`/User/GetTenantUserDetail`).then((response) => {
      if (response.success) {
        if (response.data.isAdmin === false) {
          setIsEditAllowed(false);
        }
      }
    });

    RequestHandler.get(
      `/TenantUser?$filter=isActive eq true and isDeleted eq false &$select=id,firstName,lastName`
    ).then((res) => {
      setTenantUserSelect({ data: res.value, loading: false });
      if (props.data?.tenantUserIds) {
        var customersForEntity = res.value.filter((item) =>
          props.data.tenantUserIds.some((x) => x.id == item.id)
        );
        setDefaultTenantUserIds(customersForEntity);
        setLastSelectedTenantUserIds(props.data?.tenantUserIds);
      }
      getProjectStatus();
    });

    RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name`).then((res) => {
      setFirmSelect({ data: res?.value, loading: false });
    });
  }, [props.data]);

  const getProjectStatus = () => {
    setProjectStatusSelect({ data: [], loading: true });

    RequestHandler.get(`/ProjectStep/GetProjectStatus`).then((res) => {
      setProjectStatusSelect({ data: res, loading: false });
    });
  };

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    values.tenantUserIds =
      lastSelectedTenantUserIds ?? props.data?.tenantUserIds;
    RequestHandler.put(`/ProjectStep`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  //    #region  Excel

  const downloadExcelTemplate = () => {
    window.open(
      `${
        config.apiUrl
      }/ProjectStep/DownloadExcel?t=${RequestHandler.getToken()}`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/ProjectStep/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/ProjectStep/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };
  // #endregion

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onTenantUserSearch = (value) => {
    setTenantUserSelect({ ...tenantUserSelect, loading: true });
    RequestHandler.get(
      `/TenantUser?$select=id,firstName,lastName&$filter=isActive eq true and isDeleted eq false and ${odata.contains(
        "firstName",
        value
      )} or ${odata.contains("lastName", value)}`
    ).then((res) => {
      setTenantUserSelect({ data: res.value, loading: false });
    });
  };

  const handleChange = (values) => {
    setLastSelectedTenantUserIds(values);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="projectStepUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            {" "}
          </Form.Item>
          <Form.Item
            name="firmId"
            label="Proje :"
            rules={[
              {
                required: true,
                message: "Lütfen Proje seçiniz.",
              },
            ]}
          >
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onFirmSeach}
              disabled={props.data ? true : false}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect?.data?.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.firmBranchNumber}
                >
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ marginTop: "4%" }}
            label="Ad"
            name="name"
            rules={[
              {
                required: true,
                message: "Lütfen Ad alanını boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Açıklama"
            name="description"
            rules={[
              {
                required: true,
                message: "Lütfen Açıklama alanını boş bırakmayın.",
              },
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item label="Başlangıç Tarihi" name="startDate">
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item label="Bitiş Tarihi" name="endDate">
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>

          {isEditAllowed && (
            <Form.Item label="Yetkililer" name="tenantUserIds">
              <Select
                mode="multiple"
                allowClear
                showSearch
                placeholder="Seçiniz"
                onSearch={onTenantUserSearch}
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={tenantUserSelect.loading}
                onChange={handleChange}
                defaultValue={defaultTenantUserIds}
              >
                {props.data?.tenantUserIds && (
                  <Select.Option
                    key={props.data.tenantUserId}
                    value={props.data.tenantUserId}
                  >
                    {props.data.tenantUserName}
                  </Select.Option>
                )}

                {tenantUserSelect.data
                  .filter((x) => x.id != props.data?.tenantUserId)
                  .map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.firstName + " " + item.lastName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item label="Durum" name="status" rules={[{ required: true }]}>
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={projectStatusSelect.loading}
            >
              {projectStatusSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Not" name="specialNote">
            {/* Açıklama kutusu */}
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 8 }}
              message={
                <>
                  Proje Adımı eklerken seçeceğiniz yetkililer, proje adımı
                  özelinde yetkili olacaklardır. Proje Adımı'na not
                  ekleyip,düzenleyebilirler. Yetkililer Seçimi, Ayarlar
                  Menüsü'nde Kullanıcı Listesi'nden listelenmektedir.
                </>
              }
            />
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default ProjectStepUpdateForm;
